<template>
	<v-stepper-step ref="stepperStepWrapper" v-bind="$attrs" v-on="$listeners" >
		<slot></slot>
	</v-stepper-step>
</template>

<script>
/**
 * This is a wrapper component for the Vuetify v-sterpper-step component designed to add support
 * for 508 accessibility.
 *
 * The component adds two pieces of functionality.
 * 1. When the component is in focus and the enter button is pressed the component will emit and event "stepper-enter".
 *    The parent component can handle the event and modify the current step of the stepper.
 * 2. When the component is in focus and the user shit-tabs the component will emit and event "stepper-tab". The parent
 *    component can handle the event and modify the current component in focus. This is useful because back tabbing by
 *    default will hit all the controls that are inside a collapsed step. This lets the parent component handle the event
 *    and skip directly to the stepper-step component.
 */
export default {
	name: 'StepperStepWrapper',
	inheritAttrs: false,
	mounted () {
		// Add an event listener for keyup on the stepper component
		const step = this.$refs.stepperStepWrapper.$el;
		if (step !== null) {
			step.addEventListener('keyup', this.stepperKeyUp);
			step.addEventListener('keydown', this.stepperKeyDown);
		}
	},
	methods: {
		/**
		 * Handle keyup events on the stepper component. Emit an event "stepper-enter" when the pressed key is enter.
		 */
		stepperKeyUp: function (e) {
			if (e.key === 'Enter') {
				this.$emit('stepper-enter', this.$refs.stepperStepWrapper.step)
			}
		},
		/**
		 * Handle keydown events on the stepper component. Emit an event "stepper-back" when:
		 * - the pressed key is Shift + Tab
		 * - the stepper is in focus
		 * - the stepper is not the first step
		 */
		stepperKeyDown: function (e) {
			if (e.key === 'Tab' && e.shiftKey && this.isFocused() && parseInt(this.$refs.stepperStepWrapper.step) > 1) {
				// Return the current step number and the key down event so the parent can choose to prevent the default behavior
				this.$emit('stepper-back', { step: parseInt(this.$refs.stepperStepWrapper.step), keyDownEvent: e });
			} else if (e.key === 'Tab') {
				this.$emit('stepper-forward', { step: parseInt(this.$refs.stepperStepWrapper.step), keyDownEvent: e });
			}
		},
		isFocused: function () {
			return this.$refs.stepperStepWrapper.$el.contains(document.activeElement);
		}
	}
}
</script>

<style scoped>

</style>
